import request from '@/utils/request'


// 查询报名用户证书信息列表
export function listCompetitionSignCertificate(query) {
  return request({
    url: '/platform/competition-sign-certificate/list',
    method: 'get',
    params: query
  })
}

// 查询报名用户证书信息分页
export function pageCompetitionSignCertificate(query) {
  return request({
    url: '/platform/competition-sign-certificate/page',
    method: 'get',
    params: query
  })
}

// 查询报名用户证书信息详细
export function getCompetitionSignCertificate(data) {
  return request({
    url: '/platform/competition-sign-certificate/detail',
    method: 'get',
    params: data
  })
}

// 新增报名用户证书信息
export function addCompetitionSignCertificate(data) {
  return request({
    url: '/platform/competition-sign-certificate/add',
    method: 'post',
    data: data
  })
}

// 修改报名用户证书信息
export function updateCompetitionSignCertificate(data) {
  return request({
    url: '/platform/competition-sign-certificate/edit',
    method: 'post',
    data: data
  })
}

// 删除报名用户证书信息
export function delCompetitionSignCertificate(data) {
  return request({
    url: '/platform/competition-sign-certificate/delete',
    method: 'post',
    data: data
  })
}
